import React from 'react';
import { useTheme } from '@/contexts/ThemeContext';
import { Moon, Sun } from 'lucide-react';
import { Switch } from '@/components/ui/switch';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

export function ThemeToggle() {
  const { actualTheme, setTheme } = useTheme();

  const handleToggle = (checked: boolean) => {
    setTheme(checked ? 'dark' : 'light');
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="flex items-center gap-2 px-3 py-2 rounded-lg zen-hover zen-card zen-ripple">
            <Sun className="h-4 w-4 text-muted-foreground transition-all duration-300 zen-float" />
            <Switch
              checked={actualTheme === 'dark'}
              onCheckedChange={handleToggle}
              className="data-[state=checked]:bg-primary data-[state=unchecked]:bg-input transition-all duration-200"
            />
            <Moon className="h-4 w-4 text-muted-foreground transition-all duration-300 zen-float" style={{ animationDelay: '0.5s' }} />
            <span className="sr-only">Toggle theme</span>
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p className="bg-gradient-hero bg-clip-text text-transparent font-medium">
            {actualTheme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}